import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "separator",
  "use": "separator-usage",
  "viewBox": "0 0 4 7",
  "content": "<symbol viewBox=\"0 0 4 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"separator\">\n<path d=\"M1.53662 0.747559L3.7583 3.38818V3.43896L1.53662 6.07959H0.241699L2.46973 3.45801V3.36914L0.241699 0.747559H1.53662Z\" fill=\"#373539\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol